var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('back-btn'),_c('v-row',[_c('v-col',{attrs:{"lg":"12"}},[_c('list')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }